import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Form, Spinner } from 'react-bootstrap';
import axios from '../axiosAlertConfig';
import { UserContext } from '../../userAlertContext';

/**
 * AlertTypeCategorySelector
 *
 * Props ───────────────────────────────────────────────
 * @param {string}  selectedType
 * @param {string}  selectedCategory
 * @param {func}    onTypeChange      – (newType) => void
 * @param {func}    onCategoryChange  – (newCat)  => void
 */
const AlertTypeCategorySelector = ({
  selectedType,
  selectedCategory,
  onTypeChange,
  onCategoryChange,
  disableType = false,
}) => {
  const { iAccountID } = useContext(UserContext);

  const [loading, setLoading]         = useState(true);
  const [titles, setTitles]           = useState([]);   // array of formName
  const [categoryMap, setCategoryMap] = useState({});   // { formName: [cat,…] }

  /* pull titles + actions once */
  useEffect(() => {
    let isMounted = true;

    axios
      .get('/get-titles-new', { params: { iAccountID }, withCredentials: true })
      .then((res) => {
        if (!isMounted) return;

        const map = {};
        const names = res.data.map((row) => {
          const actions = row.actions ? JSON.parse(row.actions) : [];
          map[row.formName] = actions.length ? actions : ['USER'];
          return row.formName;
        });

        setTitles(names);
        setCategoryMap(map);
        setLoading(false);
      })
      .catch((e) => {
        console.error('fetch titles', e);
        setLoading(false);
      });

    return () => (isMounted = false);
  }, [iAccountID]);



  // ── NEW: default the selector to "Lockdown" once options are loaded ──
  useEffect(() => {
    if (loading) return;
    if (selectedType) return; // don't overwrite an existing selection

    // case-insensitive match for "Lockdown"
    const target =
      titles.find(t => t.toLowerCase() === 'lockdown') || null;
    if (target) {
      onTypeChange(target);
      const cats = (categoryMap[target] || []);
      // optionally default category to the first available (or leave blank)
      onCategoryChange(cats[0] || '');
    }
  }, [loading, selectedType, titles, categoryMap, onTypeChange, onCategoryChange]);






  const catsForSelected = categoryMap[selectedType] ?? [];

  if (loading) return <Spinner animation="border" size="sm" />;

  return (
    <Row className="g-2">
      <Col xs={12}>
        <Form.Group>
          <Form.Label className="fw-semibold mb-1">Incident Type</Form.Label>
          <Form.Select
            size="sm"
            value={selectedType}
            onChange={(e) => {
              onTypeChange(e.target.value);
              onCategoryChange(''); // reset cat
             
            }}
             disabled={disableType}
          >
            <option value="">Select Type</option>
            {titles.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>

      <Col xs={12}>
        <Form.Group>
          <Form.Label className="fw-semibold mb-1">Category</Form.Label>
          <Form.Select
            size="sm"
            value={selectedCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            disabled={!selectedType}
          >
            <option value="">Select Category</option>
            {catsForSelected.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>
  );
};

export default AlertTypeCategorySelector;
